<template lang='pug'>
  div#home
    //- infobar
    rss(destination-url='https://www.reddit.com/r/esist' feed-url='https://www.reddit.com/r/esist.rss' title='Reddit:r/esist' hide='description')
    rss(destination-url='https://www.reddit.com/r/worldnews' feed-url='https://www.reddit.com/r/worldnews.rss' title='Reddit:r/WorldNews' hide='description')
    rss(destination-url='https://www.reddit.com/r/politics' feed-url='https://www.reddit.com/r/politics.rss' title='Reddit:r/Politics')
    rss(destination-url='https://fivethirtyeight.com/politics' feed-url='https://fivethirtyeight.com/politics/feed/' title='538:Politics')
    rss(destination-url='http://thehill.com/homenews/administration' feed-url='http://thehill.com/taxonomy/term/1132/feed' title='TheHill:Administration')
    rss(destination-url='https://www.reddit.com/r/TrumpCriticizesTrump' feed-url='https://www.reddit.com/r/TrumpCriticizesTrump.rss' title='Reddit:r/TrumpCritcizesTrump' includes='' hide='description')
    rss(destination-url='https://www.reddit.com/r/liestrumptoldus' feed-url='https://www.reddit.com/r/liestrumptoldus.rss' title='Reddit:r/liestrumptoldus' hide='description')
    rss(destination-url='http://politico.com' feed-url='http://www.politico.com/rss/politicopicks.xml' title='Politico:Politics')
</template>

<script>
import Approval from './Approval'
import Rss from './RSS'
// import InfoBar from './InfoBar'

export default {
  name: 'home',
  components: {
    Approval,
    Rss
    // 'infobar': InfoBar
  },
  data () {
    return {
    }
  },
  created () {
    this.pageName = 'Home'
  },
  methods: {
  },
  mounted () {
    //   /*eslint-disable */
    //   const a = document.getElementsByTagName('a')
    //   for (let i = 0; i < a.length; i++) {
    //     console.log(a[i], 'link')
    //     if (a[i].href.indexOf(location.host) === -1 && a[i].href.match(/^http:\/\//i)) {
    //       a[i].onclick = function (e) {
    //         console.log('THIS IS A CLICK')
    //         e.preventDefault()
    //         _gaq.push(['_trackEvent', 'outgoing_links', this.href.replace(/^http:\/\//i, '')])
    //         window.open(a[i].href, '_blank')
    //       }
    //     }
    //   }
    //   /*eslint-enable */
    // }, 2000)
  }
}
</script>

<style lang="stylus">
  // #day
  //   position fixed
  //   top 10px
  //   right 5px
  //   transform rotate(45deg)
  //   color rgba(0, 0, 0, 0.2)
  //   text-decoration none
  //   &:hover
  //   color rgba(0, 0, 0, 1)
</style>



// WEBPACK FOOTER //
// Home.vue?2dc681f0